"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketMessageTypeEnum = void 0;
var SocketMessageTypeEnum;
(function (SocketMessageTypeEnum) {
    SocketMessageTypeEnum[SocketMessageTypeEnum["System"] = 0] = "System";
    SocketMessageTypeEnum[SocketMessageTypeEnum["HotOrder"] = 50] = "HotOrder";
    SocketMessageTypeEnum[SocketMessageTypeEnum["HotOrderTaked"] = 51] = "HotOrderTaked";
    SocketMessageTypeEnum[SocketMessageTypeEnum["OrderChanged"] = 52] = "OrderChanged";
})(SocketMessageTypeEnum || (exports.SocketMessageTypeEnum = SocketMessageTypeEnum = {}));
//# sourceMappingURL=SocketMessageTypeEnum.js.map